import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Contrast } from "../../../types/general.types";
import { useState } from "react";
import { Icon, IconButton } from "../../../Molecules";
import { SearchInputVariants } from "./constants";
import { SearchInputContainer, StyledInput } from "./SearchInput.style";
import { IconButtonVariants, IconButtonWeights, } from "../../../Molecules/Button/Icon/constants";
const SearchInput = ({ onChange = (e) => { }, contrast = Contrast.default, variant = SearchInputVariants.primary, ...props }) => {
    const [value, setValue] = useState("");
    const handleChange = (e) => {
        e.preventDefault();
        setValue(e.target.value);
        onChange(e);
    };
    const clearInput = () => {
        const clearEvent = {
            target: { value: "" },
            preventDefault: () => { },
        };
        handleChange(clearEvent);
    };
    return (_jsxs(SearchInputContainer, { contrast: contrast, variant: variant, children: [_jsx(Icon, { name: "itaufonts_busca_consulta", size: "medium", contrast: contrast }), _jsx(StyledInput, { onChange: handleChange, contrast: contrast, value: value, ...props }), value !== "" && (_jsx(IconButton, { iconName: "itaufonts_fechar", weight: IconButtonWeights.medium, onClick: clearInput, variant: IconButtonVariants.neutral, contrast: contrast }))] }));
};
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map